import { dronesApi } from './drones';
import { flightTypesApi } from './flightTypes';
import { authApi } from './auth';
import { notesApi } from './notes';
import { filesApi } from './files';
import { documentsApi } from './documents';
import { maintenanceApi } from './maintenance';
import { llmApi } from './llm';
import { maintenanceDocsApi } from './maintenanceDocs';
import { tendersApi } from './tenders';
import { announcementsApi } from './announcements';
import { profilesApi } from './profiles';
import { reportsApi } from './reports';
import { legacyHoursApi } from './legacyHours';
import { inventoryApi } from './inventory';
import { operationsApi } from './operations';
import { analyticsApi } from './analytics';
import { agentsApi } from './agents';
import { manufacturingApi } from './manufacturing';
import { softwareReleasesApi } from './softwareReleases';
import { flightSharesApi } from './flightShares';
import { objectSharesApi } from './objectShares';
import { fileObjectsApi } from './fileObjects';
import { flightLinksApi } from './flightLinks';

// Assembles the public `apiService` surface from per-domain modules.
// Spreading preserves the original flat object shape exactly, so all ~63
// call sites keep working unchanged via the `src/services/api.ts` barrel.
export const apiService = {
  ...dronesApi,
  ...flightTypesApi,
  ...authApi,
  ...notesApi,
  ...filesApi,
  ...documentsApi,
  ...maintenanceApi,
  ...llmApi,
  ...maintenanceDocsApi,
  ...tendersApi,
  ...announcementsApi,
  ...profilesApi,
  ...reportsApi,
  ...legacyHoursApi,
  ...inventoryApi,
  ...operationsApi,
  ...analyticsApi,
  ...agentsApi,
  ...manufacturingApi,
  ...softwareReleasesApi,
  ...flightSharesApi,
  ...objectSharesApi,
  ...fileObjectsApi,
  ...flightLinksApi,
};

export { getAuthToken, getApiBaseUrl, configureApiAuth } from './_client';
